import { type IconNames, SvgIcon } from '@cinch-labs/design-system'
import { StoryBenefitsEvCard } from '../../types/electric-cars-page'

import styles from './ev-benefits.module.css'
import sharedStyles from '../../landing-feature-electric-cars.module.css'

interface EvBenefitsProps {
  evBenefits: StoryBenefitsEvCard[]
}

const BenefitCard = ({ benefit }: { benefit: StoryBenefitsEvCard }) => {
  const { icon, title, text } = benefit
  type IconNamesUnion = `${IconNames}`
  //Current prod usp icons
  const mappedIconName: Record<string, IconNamesUnion> = {
    EmissionsIcon: 'co2',
    WalletIcon: 'wallet',
    EngineIcon: 'engine',
    BatteryChargeIcon: 'charge',
    BatteryFullIcon: 'battery-full',
    ShareIcon: 'share', //TODO: Add matching Share icon to DSv1
  }
  return (
    <li className={styles.cardContainer}>
      <div className={styles.iconContainer}>
        <SvgIcon name={mappedIconName[icon]} size={24} />
      </div>
      <div className={styles.textContainer}>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.text}>{text}</p>
      </div>
    </li>
  )
}

export const EvBenefits = ({ evBenefits }: EvBenefitsProps) => (
  <section>
    <h3 className={sharedStyles.heading}>Benefits of an electric car</h3>
    <ul className={styles.cardList}>
      {evBenefits.map((benefit) => (
        <BenefitCard key={`benefit-${benefit.title}`} benefit={benefit} />
      ))}
    </ul>
  </section>
)
